export const sizes = Object.freeze({
  scrollbar: "15px",
  "container-2xl": "1664px",
});
